import React, { FC, ReactNode } from 'react';

import classNames from 'classnames';

import './Box.scss';

interface IBox {
	className?: string;
	children?: ReactNode;
}

const Box: FC<IBox> = ({ children, className }) => {
	return <div className={classNames('box', { [className]: !!className })}>{children}</div>;
};

export { Box };
